import { validateChinese, validatenum } from "@/util/validate";

const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
};

export const pipelineTestingTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  size: "mini",
  selection: true,
  menu: true,
  menuBtnTitle: "更多",
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "80",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "代理商",
      prop: "rootDepartId",
      type: "select",
      search: true,
      hide: true,
    },
    {
      label: "预约人姓名",
      prop: "contactName",
      type: "input",
      search: true,
      overHidden: true,
      rules: [{ required: true, trigger: "blur", validator: validateName }],
    },
    {
      width: 120,
      label: "预约人电话",
      prop: "contactMobile",
      type: "input",
      search: true,
      overHidden: true,
      rules: [{ required: true, trigger: "blur", validator: validateNumber }],
    },
    {
      label: "预约人类型",
      prop: "paintType",
      type: "select",
      overHidden: true,
      dicData: [
        { label: "业主", value: "1" },
        { label: "水工", value: "2" },
        { label: "工长", value: "3" },
        { label: "经销商", value: "4" },
        { label: "项目经理", value: "5" },
        { label: "装饰公司", value: "6" },
      ],
    },
    {
      label: "服务类型",
      prop: "appointmentType",
      type: "select",
      overHidden: true,
      dicData: [
        { label: "水管服务", value: "1" },
        { label: "地暖服务", value: "2" },
        { label: "前置服务", value: "3" },
        { label: "地暖清洗服务", value: "5" },
        { label: "中央配水服务", value: "6" },
        { label: "暖气片管道服务", value: "7" },
      ],
    },
    {
      label: "装修公司",
      prop: "otherRequirements",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      width: 140,
      label: "装修公司电话",
      prop: "otherProducts",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      label: "水工姓名",
      prop: "introducer",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      width: 140,
      label: "水工电话",
      prop: "reference",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      label: "项目经理名称",
      prop: "lineLength",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      label: "预约进场时间",
      prop: "entranceTime",
      type: "datetime",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm",
    },
    {
      label: "报单商家名称",
      prop: "shopName",
      type: "input",
      search: true,
      rules: [{ required: true, trigger: "blur", validator: validateName }],
    },
    {
      label: "报单商家电话",
      prop: "shopMobile",
      type: "input",
      search: true,
      rules: [{ required: true, trigger: "blur", validator: validateNumber }],
    },
    {
      label: "业主姓名",
      prop: "customName",
      span: 12,
      search: true,
      type: "input",
      rules: [{ required: true, trigger: "blur", validator: validateName }],
    },
    {
      label: "实际报单人电话",
      prop: "actualDeclarerPhone",
      span: 12,
      search: true,
      type: "input",
      rules: [{ required: true, trigger: "blur", validator: validateNumber }],
    },
    {
      label: "业主地址",
      prop: "customAddress",
      span: 12,
      search: true,
      type: "input",
    },
    {
      label: "提单方式",
      prop: "lowerLevelType",
      type: "select",
      search: true,
      overHidden: true,
      dicData: [
        { label: "自主预约", value: "1" },
        { label: "分享预约", value: "0" },
      ],
    },
    // 日丰订单号：safetyBookingCode
    {
      label: "日丰订单号",
      prop: "safetyBookingCode",
      type: "input",
      search: true,
      overHidden: true,
    },
    // 日丰唯一标识：safetyGuardDetailId
    {
      label: "日丰唯一标识",
      prop: "safetyGuardDetailId",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      label: "提单时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "开始时间",
      prop: "timeStart",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      prop: "timeEnd",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "备注",
      prop: "remarks",
      type: "textarea",
      span: 24,
      overHidden: true,
      max: 255,
    },
  ],
};
